<template>
<section style="height: 100vh;display: flex;justify-content: center;">
    <div class="modal animated fadeIn show oppay" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered ">
            <button name="closeModal" type="button" id="close" ref="close" class="close" data-dismiss="modal" @click.prevent="cancel"></button>
            <div class="row">
                <div class="col-12">
                    <div class="opt-content card">
                        <div class="opt-content-wrapper active pay-pane p-4 active">
                            <div class="text-center">
                                <i class="title-icon warning"></i>
                            </div>

                            <h3 class="text-center">Unable to process transaction</h3>

                            <p v-if="hasMessage" class="mb-4" v-text="message"></p>
                            <p v-else class="mb-4">This transaction must have been completed, is invalid or does not exist.</p>

                            <div v-if=" client_info.colors !== undefined" class="modal-body">
                                <div class="row m-0">
                                    <div v-if="failedFromStart == 'false' || !failedFromStart" class="col-12 px-0">
                                        <div v-if="failedFromStart == 'false' || !failedFromStart" class="form-group text-center mb-2 mt-3">
                                            <button type="button" class="btn app-bg-color" :style="style" @click.prevent="tryAgain"> Try Again</button>
                                        </div>

                                        <div class="form-group text-center mb-0 mt-4">
                                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny" @click.prevent="continueToMerchant">
                                                {{ !failedFromStart ? '&larr; '  : ''  }} {{ client_info.merchant && client_info.merchant.return_text ? client_info.merchant.return_text :  'Back to merchant'}}
                                            </a>
                                        </div>
                                    </div>
                                    <div v-else-if=" client_info == 'undefined'" class="col-12 px-0">
                                        <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="btn app-bg-color" @click.prevent="continueToMerchant">'Back to merchant</a>
                                    </div>

                                    <div v-else class="col-12 px-0">

                                        <div class="form-group text-center my-4">
                                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="btn app-bg-color" @click.prevent="continueToMerchant" :style="{ background : appColor, color: client_info.colors.payment_description ? client_info.colors.payment_description + '!important' : '' }">
                                                {{ !failedFromStart ? '&larr; ' : ''  }} {{ client_info && client_info.merchant && client_info.merchant.return_text ? client_info.merchant.return_text :  'Back to merchant'}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="modal-body ">
                                <div class="row m-0 text-center">
                                    <div class="col-12 px-0 mt-5">
                                        <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny" @click.prevent="closeIframe">Close</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
/* eslint-disable */
export default {
    name: 'warning',
    created() {
        this.hasMessage = true;

        try {
            // console.log(this.$store.state)
            if (window.failedFromStart) {
                this.failedFromStart = window.failedFromStart;
            }

            if (window.failedFromStartMessage) {
                this.message = window.failedFromStartMessage
            }

            if (this.$store.state.client_info)
                this.client_info = this.$store.state.client_info;

            if (this.client_info == 'null' || this.client_info !== null)
                if (typeof this.client_info.colors != "undefined" || typeof this.client_info.colors == 'object') {
                    this.style = {
                        background: this.client_info.colors.primary_button ? this.client_info.colors.primary_button + ' !important' : appColor,
                        color: this.client_info.colors.payment_description ? this.client_info.colors.payment_description + '!important' : ''
                    }

                    if (window.raw && JSON.parse(window.raw).status) {
                        var res = JSON.parse(window.raw)

                        this.hasMessage = true;
                        this.message = res.message;
                        
                        if (this.client_info && this.client_info !== null && this.client_info.colors)
                            this.appColor = this.client_info.colors.app + " !important" || this.client_info.colors.primary_button + " !important";
                        else {
                            this.appColor = 'grey'
                        }

                    }
                }
        } catch (e) {
            console.log(e)
        }

    },
    data() {
        return {
            hasMessage: false,
            message: '',
            appColor: '',
            style: {},
            client_info: '',
            env: false,
            failedFromStart: '',
        }
    },
    methods: {
        cancel() {
            this.closeIframe();
        },
        tryAgain() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`; 
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.$router.push('/v2/popup');
            
        },
        continueToMerchant() {

            try{
                let referrer = this.$store.state.popupReferrer
                if (!window.raw) {
                    var response = {
                        status: 'Failed',
                        message: this.message || "Could not locate errors",
                        data: null,
                    }
                } else {
                    var res = JSON.parse(window.raw)
                    res && res.data ? delete res.data.client_info : '';
                    res && res.data ? delete res.data.paymentoptions : '';

                    //
                    let provider;
                    if (this.$store.state.showDefaultView) {
                        if (this.$store.state.payload.transaction.options && this.$store.state.payload.transaction.options.default_view) {
                            provider = this.$store.state.payload.transaction.options.default_view.provider;
                            res.data.provider = provider;
                        }
                    }

                    var response = {
                        status: res ? res.status || "Failed" : "Failed",
                        message: this.message || (res && res.data ? res.data.message : 'No message from the server') || "Could not locate errors",
                        data: res && res.data ? res.data || null : null,
                    }
                }

                if (this.$store.state.isFailed)
                    response.parentTransRef = this.$store.state.parentTransRef

                if (window.failedFromStart == 'false') {
                    response.reference = this.$store.state.transRef || null;
                    response.optionsTransRef = this.$store.state.options.optionsTransRef || null;
                    response.paymentmethod = this.$store.state.paymentMethod || null;
                }

                this.$store.replaceState({
                    paymentMethod: '',
                    paymentMethodIndex: '',
                    client_info: {},
                    service_call_payload: {},
                    payload: {},
                    options: {},
                    api_key: null,
                    isFailed: false,
                    hasPaid: false,
                    hasOtp: false,
                    isLoading: true,
                    channels: {},
                    popupReferrer: null,
                    provider: {},
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    parentTransRef: '',
                    optionsTransRef: '',
                    showDefaultView: false,
                    transRef: '',
                    cardDetails: {
                        card_cc: '',
                        card_exp: '',
                        card_cvv: '',
                        card_pin: '',
                    },
                    customer_processing_fee: 0.00,
                });

                if (this.$route.name !== 'popup-v2')
                    this.$router.push('/v2/popup').catch(err => {});

                response.status = "Failed";
                this.client_info = null;
                window.parent.postMessage(JSON.stringify(response), referrer.includes("file://") ? "*" : referrer);
            }catch(e){
                console.log('continueToMerchant', e)
            }
        },
        closeIframe() {
            try{
            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                service_call_payload: {},
                payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                },
                customer_processing_fee: 0.00,
            });

            if (this.$route.name !== 'popup-v2')
                this.$router.push('/v2/popup');

            if (isIframe)
                window.parent.postMessage('close', '*');
            else
                console.log("Can only close in an iframe");

            }catch(e){
                console.log('CloseIframe', e)
            }

        }
    }
};
</script>

<style scoped>
.modal.oppay button.close {
    right: -50px;
}

.text-tiny gray {
    font-size: 14px;
    ;
}
</style>
